export default "__VITE_ASSET__d32888ba__"